<template>
  <a class="row total" :href="orderPath">
    <div class="name">{{ $t('total') }}
    </div>
    <div class="price">{{ totalAmount | currency }}</div>
    <div class="action">
      <i class="icon-order-arrow-right" />
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['totalAmount', 'orderPath']),
  },
};
</script>

<i18n>
{
  "cs": {
    "total":  "Celkem"
  },
  "sk": {
    "total":  "Celkem:"
  },
  "en": {
    "total":  "Total:"
  }
}
</i18n>
